import { createContext } from 'react'
import { TabContextValue } from './tab-context.interface'

export const TabContext = createContext<TabContextValue>({
  currentTabIndex: 0,
  setCurrentTabIndex: () => {},
  prevTabIndex: 0,
  setPrevTabIndex: () => {},
})
